import Types from '../reducers/globalTypes';
import {dispatch} from './store';

let connection = null,
    connection_type = null;

let state = {
    initialized: false,
    authorized: false,
    providerId: null
}

const log = log => console.log(`[WS] ${log}`),
      send = data => connection.send(JSON.stringify(data));

const connect = () => {
    connection = new WebSocket(`${window.location.origin.replace('http', 'ws')}/ws`);

    connection.onopen = () => {
        log(`Connection open`);

        if(!state.authorized && state.providerId)
            authorize();
    }

    connection.onmessage = res => {
        try {
            res = JSON.parse(res.data);
        } catch(e) {
            return log(`Wrong response`, res);
        }

        switch(res.type) {
            case 'balance':
                return dispatch({
                    type: Types.user.balance,
                    payload: res.payload
                }); 
            case 'bonus_state':
                return dispatch({
                    type: Types.user.bonus_state,
                    payload: res.payload
                }); 
            case 'bets_amount':
                return dispatch({
                    type: Types.user.bets,
                    payload: res.payload
                }); 
            case 'authorized':
                state.authorized = true;
                return log(`Successfully logged in [${connection_type}]`);
            case 'unauthorized':
                return log(`Successfully logout`);
        }
    }

    connection.onclose = () => {
        log('Connection closed')

        state.authorized = false;
        return setTimeout(connect, 3e3);
    }
}

function init() {
    if(state.initialized)
        return;

    state.initialized = true;
    connect();
}

function logout() {
    if(!connection || connection.readyState !== WebSocket.OPEN)
        return setTimeout(logout, 1e3);

    state.authorized = false;
    state.providerId = null;

    send({
        type: 'logout'
    });
}

function authorize(providerId=false, isGuest=false) {
    if(!connection || connection.readyState !== WebSocket.OPEN)
        return setTimeout(authorize, 1e3, providerId, isGuest);

    if(state.authorized)
        return;

    if(!state.providerId && !providerId)
        return;

    if(providerId)
        state.providerId = providerId;

    connection_type = isGuest ? 'guest' : 'user';

    send({
        type: 'authorize',
        payload: state.providerId
    });
}

export default {
    init,
    authorize,
    logout
}